// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e7913c59","453":"94aef374","732":"8a1354fb","977":"e82aff31"}[chunkId] + ".chunk.js";
};